<template>
  <div class="dg-youtube-playlist" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="youtube-container">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/tCWnfLXd3-4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  }
};
</script>

<style scoped>
.dg-youtube-playlist {
  background: var(--primary-dark);
  padding: 0px 15px;
}
.dg-youtube-playlist[data-brand="mazda"] {
  background: #fff;
  padding: 30px 15px;
}
.dg-youtube-playlist .youtube-container {
  max-width: 800px;
  margin: auto;
}
.dg-youtube-playlist .youtube-container .embed-responsive {
  background-image: url(../../static/images/youtube-backup-bg.png);
  background-size: cover;
  background-position: center;
}
</style>